import React, { Fragment, useEffect, useState } from 'react'
import SelectInput from '../../../Common/ui/selectInput'
import * as OnboardEntites from '../../../Entities/OnBoardingContainerTypes'
import PropTypes from 'prop-types'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import * as GovernanceApi from '../../../API/GovernenceAPI'
import Loading from 'src/Common/ui/Loading'
import { INFORMED_DEPARTMENT, INFORMED_INDEX_RACI, INFORMED_ROLE, RACI_ROUTE_COMPLIANCE_ADD, RACI_ROUTE_COMPLIANCE_EDIT, TOTAL_API_HIT_COUNT } from 'src/Entities/Governance'
import { useLocation } from 'react-router'
import { MENU_TYPE_COMPLIANCE, MENU_TYPE_GOVERNANCE } from 'src/Entities/MainContainerTypes'

function Racilist ({ type = MENU_TYPE_COMPLIANCE, getState, tempRaciMatrix, reset, raciiMatrices, setRaciiMatrices, editNode, control, errors }) {
    const updateRaciOptions = useGovernanceStore(state => state.updateRaciOptions)
    const { raciMatrixOptions } = useGovernanceStore()
    const [ loading, setLoading ] = useState(false)
    const location = useLocation()
    useEffect(() => {
        if (raciiMatrices?.length > 0) {
            let raciResetData = {}
            raciiMatrices.map((item, i) => {
                return {
                    department: item.departmentId, role: item.roleId, user: item.userId
                }
            }).map((item, i) => {
                const final = Object.keys(item).map((ele, j) => {
                    raciResetData = { ...raciResetData, [`raci-${j + 1}-${i}`]: item[ele] }
                    return ele
                })
                return final
            })
            reset(raciResetData)
        }
    }, [raciiMatrices])
    const orgId = localStorage.getItem('orgId')
    const [ apiGetCount, setApiGetCount ] = useState(0)
    useEffect(() => {
        if (apiGetCount === +TOTAL_API_HIT_COUNT) {
            setLoading(false)
        }
    }, [apiGetCount])
    useEffect(() => {
        let raciMatrixData = raciMatrixOptions
        const raciMat = tempRaciMatrix?.length > 0
            ? tempRaciMatrix
            : [
                {
                    raciId: 1,
                    organizationId: getState.organizationId,
                    orgRegulationId: getState.id
                }
            ]
        setLoading(true)
        let count = 0
        raciMat?.forEach((getData, i) => {
            Object.keys(raciMatrixData).forEach(async (item, j) => {
                if (j !== INFORMED_INDEX_RACI) {
                    if (i === j) {
                        GovernanceApi.getDepOrg(getData.organizationId).then(({ data }) => {
                            setLoading(true)
                            if (data?.length > 0) {
                                raciMatrixData = {
                                    ...raciMatrixData,
                                    [item]: {
                                        ...raciMatrixData[item],
                                        department: data?.map((item) => {
                                            return {
                                                value: item.id,
                                                label: item.name
                                            }
                                        })
                                    }
                                }
                            }
                            return data
                        }).then((data) => {
                            if (data?.length > 0) {
                                setLoading(true)
                                GovernanceApi.getRolebyDep(getData.departmentId).then(({ data }) => {
                                    raciMatrixData[item].roles = data?.map((item) => {
                                        return {
                                            value: item?.id,
                                            label: item.name
                                        }
                                    })
                                    return data
                                }).then((data) => {
                                    setLoading(true)
                                    GovernanceApi.getUserByRole(getData.roleId, getData.organizationId, getData.departmentId).then(({ data }) => {
                                        raciMatrixData[item].user = data?.map((item) => {
                                            return {
                                                value: item?.id,
                                                label: item.name
                                            }
                                        })
                                        updateRaciOptions(raciMatrixData)
                                        count++
                                        setApiGetCount(count)
                                    })
                                    return data
                                })
                            }
                        })
                    }
                } else {
                    if (i === j) {
                        setLoading(true)
                        GovernanceApi.getManagementTeam(orgId).then(({ data }) => {
                            raciMatrixData = {
                                ...raciMatrixData,
                                informed: {
                                    department: INFORMED_DEPARTMENT,
                                    roles: INFORMED_ROLE,
                                    user: data.map((ele) => {
                                        return {
                                            value: ele?.id,
                                            label: ele?.name
                                        }
                                    })
                                }
                            }
                            updateRaciOptions(raciMatrixData)
                            count++
                            setApiGetCount(count)
                        })
                    }
                }
                return item
            })
            return getData
        })
    }, [tempRaciMatrix])

    function handleuserChange (user, item, i, options) {
        const isNone = user === null || user === undefined
        const findLabel = isNone ? null : options.find((ele) => ele.value === +user)
        setRaciiMatrices(raciiMatrices.map((ele, j) => {
            if (i === j) {
                return { ...ele, userId: isNone ? null : user, user: findLabel?.label ?? '' }
            }
            return ele
        }))
    }

    function getUserByRolesSelect (role, item, i, options, deptId) {
        const isNone = role === null || role === undefined
        const findLabel = isNone ? null : options.find((ele) => ele.value === +role)
        setRaciiMatrices(raciiMatrices.map((ele, j) => {
            if (i === j) {
                return { ...ele, roleId: isNone ? null : role, role: findLabel?.label ?? '', userId: null, user: '' }
            }
            return ele
        }))
        const raciOptions = raciMatrixOptions
        if (isNone) {
            updateRaciOptions({ ...raciOptions, [item]: { ...raciOptions[item], user: [] } })
            return
        }
        GovernanceApi.getUserByRole(role, getState.organizationId, deptId)
            .then(({ data }) => {
                const finalData = data.map(obj => ({ value: obj.id, label: obj.name }))
                updateRaciOptions({ ...raciOptions, [item]: { ...raciOptions[item], user: finalData } })
            })
    }
    useEffect(() => {
        if (location.pathname.includes(RACI_ROUTE_COMPLIANCE_EDIT) || location.pathname.includes(RACI_ROUTE_COMPLIANCE_ADD)) {
            setRequiredKeys(OnboardEntites.RACI_MATRIX_REQUIRED_KEYS_COMPLIANCE)
        } else {
            setRequiredKeys(OnboardEntites.RACI_MATRIX_REQUIRED_KEYS_REGULATORY)
        }
    }, [location.pathname])
    const [ requiredKeys, setRequiredKeys ] = useState([])
    function getRolesbyDepSelect (dep, item, i, options) {
        const matrices = [...raciiMatrices]
        const isNone = dep === null || dep === undefined

        const raciOptions = raciMatrixOptions
        if (isNone) {
            setRaciiMatrices(matrices.filter((_, j) => j !== i))
            updateRaciOptions({ ...raciOptions, [item]: { ...raciOptions[item], roles: [], user: [] } })
            return
        }

        setRaciiMatrices(matrices.map((obj, j) => {
            if (i === j) {
                return { ...obj, departmentId: dep, department: options.find((ele) => ele.value === +dep)?.label, roleId: null, role: '', userId: null, user: '' }
            }
            return obj
        }))

        if (!matrices.find((ele, k) => k === i)) {
            setRaciiMatrices([ ...matrices, {
                raciId: matrices.length + 1,
                organizationId: editNode.organizationId,
                orgId: editNode.organizationId,
                orgRegulationId: getState.id,
                departmentId: dep,
                department: options.find((ele) => ele.value === +dep)?.label
            }])
        }

        GovernanceApi.getRolebyDep(dep)
            .then(({ data }) => {
                const finalData = data.map(obj => ({ value: obj.id, label: obj.name }))
                updateRaciOptions({ ...raciMatrixOptions, [item]: { ...raciMatrixOptions[item], roles: finalData, user: [] } })
            })
    }
    const noneImplementor = (list = []) => {
        return [ ...list, { label: 'None', value: null }]
    }
    return (
        <>
            <Loading isLoading={loading} />
            <div className='regulation-raci-matrix'>
                <div />
                <p className='regulation-qn-title text-primary'>Department<span className='text-[red]'>*</span></p>
                <p className='regulation-qn-title text-primary'>Role<span className='text-[red]'>*</span></p>
                <p className='regulation-qn-title text-primary'>Name</p>
                {Object.keys(raciMatrixOptions)?.map((item, index) => {
                    if (OnboardEntites.RACI_MATRIX_KEYS.includes(item)) {
                        if (type === MENU_TYPE_GOVERNANCE && index === 0) return null
                        return (
                            <Fragment key={index}>
                                <p className='regulation-qn-label
                                capitalize mt-5'>{item}{requiredKeys.includes(item) && <span className='text-[red]'>*</span>}</p>
                                <div>
                                    <SelectInput
                                        placeholder="Select"
                                        name={`raci-1-${index}`}
                                        control={control}
                                        required
                                        errors={errors}
                                        readOnly={index === INFORMED_INDEX_RACI}
                                        rules={requiredKeys.includes(item) ? { required: 'This field is required' } : {}}
                                        options={noneImplementor(raciMatrixOptions[item]?.department)}
                                        value={raciiMatrices && raciiMatrices[index]?.departmentId}
                                        className='relative'
                                        defaultValue={raciiMatrices && raciiMatrices[index]?.departmentId}
                                        onValueChange={value => getRolesbyDepSelect(value, item, index, raciMatrixOptions[item]?.department, 'department')} />
                                </div>
                                <div>
                                    <SelectInput
                                        placeholder="Select"
                                        required
                                        name={`raci-2-${index}`}
                                        control={control}
                                        errors={errors}
                                        readOnly={index === INFORMED_INDEX_RACI}
                                        rules={requiredKeys.includes(item) ? { required: 'This field is required' } : {}}
                                        options={noneImplementor(raciMatrixOptions[item]?.roles) }
                                        value={raciiMatrices && raciiMatrices[index]?.roleId}
                                        defaultValue={raciiMatrices && raciiMatrices[index]?.roleId}
                                        onValueChange={value => getUserByRolesSelect(value, item, index, raciMatrixOptions[item]?.roles, raciiMatrices[index]?.departmentId)} />
                                </div>
                                <div>
                                    <SelectInput
                                        placeholder="Select"
                                        required
                                        name={`raci-3-${index}`}
                                        control={control}
                                        options={noneImplementor(raciMatrixOptions[item]?.user)}
                                        value={raciiMatrices && raciiMatrices[index]?.userId}
                                        defaultValue={raciiMatrices && raciiMatrices[index]?.userId}
                                        onValueChange={value => handleuserChange(value, item, index, raciMatrixOptions[item]?.user)} />
                                </div>
                            </Fragment>
                        )
                    } else {
                        return null
                    }
                })}
            </div>
        </>
    )
}

Racilist.propTypes = {
    selectedValues: PropTypes.object,
    setSelectedValues: PropTypes.func,
    onSelectedTableValueChange: PropTypes.func,
    control: PropTypes.any,
    errors: PropTypes.any,
    getState: PropTypes.any,
    reset: PropTypes.any,
    raciiMatrices: PropTypes.any,
    tempRaciMatrix: PropTypes.any,
    setRaciiMatrices: PropTypes.any,
    editNode: PropTypes.any
}

export default Racilist
